var exports = {
  "nf": "x93eb46d8--eaddb6--link",
  "Sl": "x93eb46d8--eaddb6--image",
  "$0": "x93eb46d8--eaddb6--title-wrapper",
  "DD": "x93eb46d8--eaddb6--title",
};

module.exports = exports;
